import { useRef, useState } from "react";
import DownloadHrmsIcon from "../../../assets/Icons/DownloadHrmsIcon";
import FileIcon from "../../../assets/Icons/FileIcon";
import MenuIcon from "../../../assets/Icons/MenuIcon";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import UploadIcon from "../../../assets/Icons/UploadIcon";
import { DropdownButton } from "./DropdownButton";
import { useParams } from "react-router-dom";
import uploadContent from "../../../utils/upload-content/uploadContent";
import {
  deleteDocumentApi,
  getDoctoImageFromAiApi,
  updateDocumentStatusApi,
  uploadDocumentsApi,
} from "../../../slices/companyMemberSlice";
import FileDownloader from "../components/FileDownload";
import useDocumentUrl from "../../../utils/dropdown-options/useDocumentUrl";
import * as constants from "../../../constant";
import axios from "axios";
import { toast } from "sonner";
import Popup from "../../../components/popup/Popup";
import CrossIcon from "../../../assets/Icons/CrossIcon";
import moment from "moment";
import ConfirmationPopup from "../../sales/ConfirmationPopup";

const roles = [
  { Id: 1, Title: "Form 16", supportedDoc: "pdf,docx" },
  {
    Id: 2,
    Title: "Gratuity Nomination Form",
    supportedDoc: "pdf,docx",
  },
  { Id: 3, Title: "Form 11", supportedDoc: "pdf,docx" },
];

const docOptions = [
  {
    Id: 1,
    Title: "Approved",
    key: "approved",
  },
  {
    Id: 2,
    Title: "Reject",
    key: "reject",
  },
];

const StatutoryDocuments = () => {
  const dispatch = useAppDispatch();

  const documentList = useAppSelector((state) => state.member.documentList);
  const memberSelector = useAppSelector((state) => state?.member.memberDetails);

  const { getDocumentUrl, getDocumentName } = useDocumentUrl();

  const userId = useAppSelector((state) => state.login.session.userId);

  const [selectedRole, setRole] = useState(null);
  const hiddenFileInput = useRef(null);
  const { memberId } = useParams();

  const handleClick = (role) => {
    setRole(role);
    hiddenFileInput.current.click();
  };

  const handleFileUpload = (response) => {
    dispatch(
      uploadDocumentsApi({
        userID: userId,
        documentType: "statutory_document",
        documentName: selectedRole?.Title,
        documentURL: response[0].url,
        uploadedBy: memberSelector.id,
        status: "In-Review",
        contentOriginalName: response[0]?.orginalFileName,
        contentType: response[0]?.contentType,
      })
    );
  };

  const getStatus = (title) => {
    let doc = documentList?.filter((doc) => doc.documentName == title);
    if (doc) {
      return doc[0]?.status;
    }
  };

  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    if (fileUploaded) {
      uploadContent.uploadEmployeeDocument(
        memberSelector.id,
        fileUploaded,
        handleFileUpload
      );
    }
  };

  const updateDocumentStatus = (status, role) => {
    const doc = getDocument(role.Title);
    dispatch(
      updateDocumentStatusApi({
        id: doc.id,
        userID: doc.userId,
        status: status,
        updatedBy: userId,
      })
    );
  };

  const getDocument = (title) => {
    let doc = documentList?.filter((doc) => doc.documentName == title);
    if (doc) {
      return doc[0];
    }
  };

  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [documentsId, setDocumentsId] = useState("");

  const togglePopUp = (documentId) => {
    setShowLogoutConfirm(true);
    setDocumentsId(documentId);
  };

  const deleteDocument = () => {
    dispatch(
      deleteDocumentApi({
        userId: memberSelector.id,
        documentId: documentsId,
      })
    )
      .unwrap()
      .then(() => {
        toast.success("Document deleted successfully");
      })
      .catch((error) => {
        console.error("Error deleting document:", error);
        toast.error("Failed to delete document");
      });
  };

  const [isPreview, setIsPreview] = useState(false);
  const [documentPreview, setDocumentForPreview] = useState(null);
  const [isDoc, setIsDoc] = useState(true);

  const token = useAppSelector((state) => state?.login?.session?.token);

  const handlePreview = async (file) => {
    if (file.contentType === "image/jpeg" || file.contentType === "image/png") {
      setIsDoc(false);
      setIsPreview(true);
      setDocumentForPreview([file.documentURL]);
    } else {
      setIsDoc(true);
      try {
        const res = await dispatch(
          getDoctoImageFromAiApi(
            `${constants.baseUrl}/${file.documentURL}?t=${token}`
          )
        ).unwrap(); // if using RTK Query
        console.log("res", res.data.images); // adjust depending on API shape
        setIsPreview(true);
        // const imageUrls = res.data.images.map((image) =>
        //   URL.createObjectURL(image)
        // );
        setDocumentForPreview(res.data.images);
      } catch (error) {
        console.error("Error in unwrap:", error);
        toast.error("Failed to fetch document preview");
      }
    }
  };

  const handleDownload = async (file) => {
    if (file.contentOriginalName) {
      try {
        const response = await axios.get(
          `${constants.baseUrl}/${file.documentURL}?t=${token}`,
          {
            responseType: "blob",
          }
        );
        const contentType = response.headers["content-type"];
        //const blob = new Blob([response.data], { type: contentType });
        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        // Fallback filename if none is provided
        let filename = file.contentOriginalName || "downloaded-file";
        if (!filename.includes(".")) {
          const extension = contentType?.split("/")[1] || "bin";
          filename += `.${extension}`;
        }
        link.href = url;
        link.setAttribute("download", filename);
        link.style.display = "none"; // optional: keep it hidden
        document.body.appendChild(link);
        link.click();
        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading file", error);
      }
    } else {
      const link = document.createElement("a");
      link.href = `${constants.baseUrl}/${file.documentURL}?t=${token}`; // your file URL
      link.setAttribute("download", ""); // optional: force download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const getDocsByTitle = (title) =>
    documentList?.filter((doc) => doc.documentName === title) || [];

  return (
    <div className="px-3 mx-auto">
      <div className="relative overflow-auto">
        <table className="w-full text-left text-gray-500">
          <thead className="text-xs text-gray-400">
            <tr>
              <th className="px-6 py-3 text-base w-4/12">Documents</th>
              <th className="px-6 py-3 text-base w-3/12">Uploader</th>
              <th className="px-4 py-3 text-base w-1/12">Status</th>
              <th className="px-6 py-3 text-base w-2/12"></th>
              {memberId !== userId && (
                <th className="px-6 py-3 text-base w-2/12">Action</th>
              )}
            </tr>
          </thead>

          <tbody>
            {roles?.map((role, index) => {
              const docs = getDocsByTitle(role?.Title);
              return (
                <tr
                  key={index}
                  className="bg-white border-b border-exgray-200/60 text-primary-400"
                >
                  {/* Documents */}
                  <td className="py-3">
                    <div className="flex items-center">
                      <FileIcon />
                      <div className="ml-3">
                        <h1>{role?.Title}</h1>
                        <p style={{ fontSize: 10 }} className="text-xs mt-1">
                          {role?.supportedDoc}
                        </p>
                      </div>
                    </div>
                    <div className="flex flex-col pl-8 mt-1">
                      {docs.map((doc, idx) => (
                        <p
                          key={idx}
                          className="text-sm text-exgray-200 text-secondary-400 mt-2"
                        >
                          {doc.contentOriginalName || "Name_Not Available"}
                        </p>
                      ))}
                    </div>
                  </td>

                  {/* Uploader */}
                  <td className="py-3">
                    <div className="flex items-center">
                      <h1>
                        {memberSelector?.firstName} {memberSelector?.lastName}
                      </h1>
                    </div>

                    <div className="flex flex-col mt-5">
                      {docs.map((doc, idx) => (
                        <p
                          key={idx}
                          className="text-sm text-exgray-200 text-secondary-400 mt-2"
                        >
                          Uploaded on{" "}
                          {moment(doc.uploadedAt).format("DD/MM/YYYY")}
                        </p>
                      ))}
                    </div>
                  </td>

                  {/* Status */}
                  <td className="py-3">
                    <div className="h-7"> </div>
                    <div className="flex flex-col mt-5">
                      {docs.map((doc, idx) => (
                        <p
                          key={idx}
                          className="text-sm text-exgray-200 text-secondary-400 mt-2"
                        >
                          {doc.status || "Not Uploaded"}
                        </p>
                      ))}
                    </div>
                  </td>

                  {/* Actions: Download + Preview */}
                  <td>
                    <div className="h-7"></div>
                    <div className="flex flex-col mt-5">
                      {docs.map((doc, idx) => (
                        <div
                          key={idx}
                          className="flex items-center gap-4 text-sm text-secondary-400 mt-2"
                        >
                          <div
                            className="cursor-pointer"
                            onClick={() => handleDownload(doc)}
                          >
                            <DownloadHrmsIcon />
                          </div>
                          <button
                            className="underline text-secondary-500"
                            onClick={() => handlePreview(doc)}
                          >
                            Prev
                          </button>
                        </div>
                      ))}
                    </div>
                  </td>

                  {/* Action Buttons */}
                  <td className="text-center">
                    {memberId === userId && (
                      <div
                        className="flex cursor-pointer m-2 border border-secondary-400 p-1 rounded-md text-center items-centr justify-center"
                        onClick={() => handleClick(role)}
                      >
                        <p className="text-xs mt-1">Upload</p>
                      </div>
                    )}
                    {memberId !== userId && (
                      <div
                        className="h-7"
                        onClick={() => handleClick(role)}
                      ></div>
                    )}

                    {docs.length > 0 && memberId !== userId && (
                      <div>
                        {docs.map((doc, idx) => {
                          return (
                            <div className="flex gap-2 mt-4 justify-center">
                              <button
                                onClick={() =>
                                  updateDocumentStatus("Reject", role)
                                }
                                className="bg-red-700 px-2 py-1 text-white rounded text-xs"
                              >
                                Reject
                              </button>
                              <button
                                onClick={() =>
                                  updateDocumentStatus("Approved", role)
                                }
                                className="bg-green-600 px-2 py-1 text-white rounded text-xs"
                              >
                                Approve
                              </button>
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {docs.length > 0 && memberId === userId && (
                      <div className="flex flex-col gap-2">
                        {docs.map((doc, idx) => {
                          if (doc.status === "In-Review") {
                            return (
                              <button
                                key={idx}
                                onClick={() => togglePopUp(doc.id)}
                                className="bg-red-700 px-2 py-1 text-white rounded text-xs"
                              >
                                Remove
                              </button>
                            );
                          } else {
                            return <div className="h-6"></div>;
                          }
                        })}
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* Hidden file input */}
        <input
          type="file"
          onChange={handleChange}
          ref={hiddenFileInput}
          style={{ display: "none" }}
        />
      </div>

      {/* Preview Modal */}
      <Popup visible={isPreview} onClose={() => setIsPreview(false)}>
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="relative w-[70%] h-[90%] p-3 pt-10 bg-white rounded shadow-lg overflow-hidden">
            <div
              className="absolute top-4 right-4 cursor-pointer"
              onClick={() => setIsPreview(false)}
            >
              <CrossIcon />
            </div>

            <div className="h-full overflow-y-auto">
              {documentPreview?.map((uri, index) => (
                <div
                  key={index}
                  className="w-full h-[calc(100vh-100px)] flex items-center justify-center"
                >
                  {isDoc ? (
                    <img
                      src={uri}
                      alt="Preview"
                      className="max-w-full max-h-full object-contain"
                    />
                  ) : (
                    <img
                      src={
                        uri.includes("http")
                          ? uri
                          : `${constants.baseUrl}/${uri}?t=${token}`
                      }
                      alt="Preview"
                      className="max-w-full max-h-full object-contain"
                    />
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Popup>
      <ConfirmationPopup
        visible={showLogoutConfirm}
        onClose={() => setShowLogoutConfirm(false)}
        onConfirm={deleteDocument}
        message="Are you sure you want to delete this file?"
      />
    </div>
  );
};

export default StatutoryDocuments;
